import { defineComponent as r, openBlock as t, createElementBlock as o, mergeProps as s, unref as e, renderSlot as m, createElementVNode as l, createCommentVNode as M } from "vue";
import { useScalarIcon as d } from "../hooks/useScalarIcon.js";
const p = { key: 0 }, i = { key: 1 }, u = { key: 2 }, g = { key: 3 }, A = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconTable"
}, y = /* @__PURE__ */ r({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(Z) {
    const V = Z, { bind: a, weight: n } = d(V);
    return (v, H) => (t(), o("svg", s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(a)), [
      m(v.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", p, H[0] || (H[0] = [
        l("path", { d: "M224,44H32A12,12,0,0,0,20,56V192a20,20,0,0,0,20,20H216a20,20,0,0,0,20-20V56A12,12,0,0,0,224,44ZM44,116H76v24H44Zm56,0H212v24H100ZM212,68V92H44V68ZM44,164H76v24H44Zm56,24V164H212v24Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", i, H[1] || (H[1] = [
        l("path", {
          d: "M88,104v96H32V104Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM216,64V96H40V64ZM40,160H80v32H40Zm176,32H96V160H216v32Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", u, H[2] || (H[2] = [
        l("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM40,160H80v32H40Zm176,32H96V160H216v32Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", g, H[3] || (H[3] = [
        l("path", { d: "M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50ZM38,110H82v36H38Zm56,0H218v36H94ZM218,62V98H38V62ZM38,192V158H82v36H40A2,2,0,0,1,38,192Zm178,2H94V158H218v34A2,2,0,0,1,216,194Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", A, H[4] || (H[4] = [
        l("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM216,64V96H40V64ZM40,160H80v32H40Zm176,32H96V160H216v32Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", f, H[5] || (H[5] = [
        l("path", { d: "M224,52H32a4,4,0,0,0-4,4V192a12,12,0,0,0,12,12H216a12,12,0,0,0,12-12V56A4,4,0,0,0,224,52ZM36,108H84v40H36Zm56,0H220v40H92ZM220,60v40H36V60ZM36,192V156H84v40H40A4,4,0,0,1,36,192Zm180,4H92V156H220v36A4,4,0,0,1,216,196Z" }, null, -1)
      ]))) : M("", !0)
    ], 16));
  }
});
export {
  y as default
};
